import React from "react";

import { Icon } from "aible";

import styles from "./style.module.css";

export default class Accordion extends React.Component {
  state = {
    hide: !this.props.defaultShow
  };

  handleToggle() {
    const { show, onClick, onToggle, disabled } = this.props;
    const { hide } = this.state;

    if (disabled) {
      return;
    }

    if (show === undefined) {
      this.setState({ hide: !hide });
    }

    onToggle && onToggle(!hide);
    return onClick && onClick();
  }

  render() {
    const {
      className,
      bodyClass,
      show,
      defaultShow,
      header,
      hideIcon,
      shrinkHeader,
      noBot,
      onClick,
      isSense,
      children,
      disabled,
      ...retProps
    } = this.props;
    const { hide } = this.state;

    const showBody = show === undefined ? !hide : show;

    return (
      <div {...retProps} className={styles.accordionWrapper + (className ? " " + className : "")}>
        <div
          className={styles.accordionHeader + (disabled ? " " + styles.isDisabled : "")}
          onClick={() => this.handleToggle()}
        >
          {header}
          {!hideIcon && !disabled ? (
            <div className={styles.accordionIndicator} style={shrinkHeader ? { marginLeft: "15px" } : undefined}>
              <Icon type={showBody ? "chevronUp" : "chevronDown"} />
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={
            styles.accordionBody +
            (showBody ? "" : " " + styles.hide) +
            " " +
            (bodyClass ? bodyClass : "") +
            " " +
            (isSense ? styles.sense : "")
          }
          style={noBot ? { marginBottom: "0px" } : {}}
        >
          {children}
        </div>
      </div>
    );
  }
}
